<template>

  <v-card flat tile class="fid-card">
    <v-layout row wrap fill-height xs12>
      <v-flex xs12 sm12 md12 lg12 xl12>

        <big-story
          v-if="!usePlayer"
          :item-reason="itemReason"
          :all-prizes="allPrizes"
          :story-header="storyHeader"
          :row-type="rowType"
        ></big-story>

      </v-flex>
    </v-layout>
  </v-card>

</template>
<script>
import { isBoss } from '@/js/store'
import Bigstory from '@/components/Bigstory'
import { SearchUtils } from '@/js'
import { VimeoVideoPicturesInfo, ProviderAuth } from '@/gql'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
export default {
  props: {
    itemReason: Object,
    usePlayer: Boolean,
    rowType: String,
    allPrizes: Array,
    editing: String,
    hostID: String,
    hostType: String,
    storyHeader: String
  },
  components: {
    'big-story': Bigstory
  },
  data: () => ({
    VimeoVideoPicturesInfo: null,
    ProviderAuth: null,
    activeSection: null
  }),
  methods: {
    // section is showable if none are showable, or its selected
    presentable (propName) {
      return !this.bigActiveSection || this.bigActiveSection === propName
    },
    ...mapMutations(vxMaps.mutations)
  },
  name: 'Big',
  computed: {
    permittedEditor () {
      // this is temporary till we figure out how to validate ownership of films
      return isBoss(this.ProviderAuth && this.ProviderAuth.userID)
    },
    // whether this page is editable, and for what reason
    editable () {
      // for testing turn on editing for bosses anyway
      return Boolean(this.editing || (this.permittedEditor ? 'fid' : ''))
    },
    breakpoint () {
      return this.$vuetify.breakpoint
    },
    userID () {
      return this.ProviderAuth && this.ProviderAuth.userID
    },
    isFilm () {
      return this.rowType === 'film' || this.rowType === 'vimeofilm'
    },
    image () {
      const path = this.isFilm &&
        this.activeSlide &&
        this.activeSlide.best &&
        this.activeSlide.best.path
      return path || SearchUtils.getImageFromReason({
        reason: this.itemReason,
        rowType: this.rowType,
        big: true
      })
    },
    story () {
      const story = SearchUtils.getStoryFromReason({ reason: this.itemReason, rowType: this.rowType, allPrizes: this.allPrizes })
      return story
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },
  apollo: {
    ProviderAuth: {
      query: ProviderAuth
    },
    VimeoVideoPicturesInfo: {
      skip () {
        const skip = this.editing !== 'vimeofilm' || this.hostType !== 'vimeo' || !this.hostID || !this.userID
        return skip
      },
      query: VimeoVideoPicturesInfo,
      variables () {
        return {
          id: this.userID,
          videoID: this.hostID,
          limit: 100
        }
      }
    }
  }

}
</script>
